import request from '@/utils/request'

/**
 * 获取商品列表
 * @param {Object} params - 查询参数
 * @param {string} params.categoryId - 分类ID
 * @param {string} params.name - 商品名称（搜索关键词）
 * @param {string} params.orderBy - 排序字段: price/sales/time
 * @param {string} params.orderType - 排序方式: asc/desc
 * @param {number} params.minPrice - 最小价格
 * @param {number} params.maxPrice - 最大价格
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export function getProductList(params) {
    return request({
        url: '/shop/product/api/list',
        method: 'get',
        params
    })
}

/**
 * 获取商品详情
 * @param {number} id - 商品ID
 * @returns {Promise}
 */
export function getProductDetail(id) {
    return request({
        url: `/shop/product/api/${id}`,
        method: 'get'
    })
}

/**
 * 获取首页分类模块列表（带参数支持，如 sectionId）
 */
export function getHomeSections(params) {
    return request({
        url: '/shop/homeCategorySection/api/home/sections',
        method: 'get',
        params
    })
}

/**
 * 获取首页详细楼层信息（带商品数据）
 */
export function getHomeSectionsWithProducts() {
    return request({
        url: '/shop/homeCategorySection/api/home/sections/with-products',
        method: 'get'
    })
}
